import { pullAt } from '@utils/vanillaJs';

export function handleChange<T>(
  store: T[] | null,
  change: T | string,
  isDelete?: boolean,
  primaryKey: string = 'id'
): T[] | undefined | null {
  if (!store) return;

  if (!change) return store as T[];

  store = store || [];

  const _isDelete = (_: T | string): _ is string => isDelete === true;
  const mStore = [...store];
  const index = mStore.findIndex(
    (doc: T) =>
      (_isDelete(change) ? change : (change as T)[primaryKey as keyof T]) ===
      (doc as T)[primaryKey as keyof T]
  );

  index > -1
    ? _isDelete(change)
      ? pullAt(mStore, [index])
      : (mStore[index] = change as T)
    : mStore.unshift(change as T);

  return mStore as T[];
}
